import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  loadingSubject = new BehaviorSubject<boolean>(false);
  private loadingQueue: string[] = [];

  get hasQueue(): boolean {
    return this.loadingQueue.length > 0;
  }

  addToLoadingQueue(url: string): void {
    this.loadingQueue.push(url);
    this.loadingSubject.next(this.hasQueue);
  }

  removeFromLoadingQueue(url: string): void {
    this.filterLoading(url);
    this.loadingSubject.next(this.hasQueue);
  }

  clearLoadingQueue(): void {
    this.loadingQueue = [];
    this.loadingSubject.next(this.hasQueue);
  }

  private filterLoading(url: string): void {
    this.loadingQueue = this.loadingQueue.filter(
      (storedUrl) => storedUrl !== url
    );
  }
}
